export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "decryption.worker.056009b7.js");
}
